<div *ngIf="socialNetworksLinks && socialNetworksLinks.length">
    <button [matMenuTriggerFor]="menu" class="btn">
        <mat-icon [svgIcon]="icon" class="share-btn-icon"></mat-icon>
        {{socialShareSettings.shareText}}
    </button>
  
    <mat-menu #menu="matMenu" xPosition="before" class="share-dropdown-menu social-share-panel">
      <div class="share-dropdown-title">{{socialShareSettings.sharePopupTitle}}</div>

      <div class="share-drop-list">
        <a *ngFor="let link of socialNetworksLinks" href="{{link.linkUrl}}" class="share-link-item" target="_blank">
            <div class="share-link-icon">
                <img [src]="link.iconUrl" [alt]="link.text">
            </div>
            <div class="share-link-name">{{link.text}}</div>
        </a>
      </div>

      <div class="copy-block">
        <button class="copy-block-button" (click)="copyLinkByBtn($event)">{{(!copied ? socialShareSettings.copyLabel : socialShareSettings.copiedLabel) }}</button>
        <input class="copy-block-input" #copyInput [readOnly]="true" [value]="eventUrl" />
        <div class="copy-block-icon">
            <img src="/Content/Images/icons/copy.svg?width=20" alt="copy" />
        </div>
      </div>
    </mat-menu>

  </div>